<template>
    <div class="bet_body box_shadow payment_opiton enter_amount">
        <div class="payment_op">{{$t('notes', 'Notes')}}</div>
        <div class="notes_div">
            <span class="count">1</span>
            <div class="n_cont">
                <span class="heading">{{$t('send-amount', 'Send Amount')}}</span>
                <span class="c_text">{{$t('deposit-amount-account', 'Send your deposit amount on the given bank account.')}}</span>
            </div>
        </div>
        <div class="notes_div">
            <span class="count">2</span>
            <div class="n_cont">
                <span class="heading">{{$t('attach-screenshot', 'Attach Screenshot')}}</span>
                <span class="c_text">{{$t('copy-utr-12', 'Copy and Enter the 12 digit UTR Number.')}}</span>
            </div>
        </div>
        <div class="border-notesBorderColor">
            <div class="border-notesBorder_w-full">
                <div class="w_col">
                    <img src="@/assets/images/right_m.svg" alt="right_m" class="r_value" />
                    <div class="flex flex-col">
                        <span class="s_ext-text_Ternary">{{$t('paid', 'Paid')}}  10,000 </span>
                        <span class="m_text-text_Ternary">9079313982@indus</span>
                    </div>
                </div>
                <div class="float-right">
                    <img src="@/assets/images/b_arr.svg" alt="right_m" />
                </div>
            </div>
            <div class="inner_sec">
                <div class="flex flex-col selected">
                    <span class="upi_d">{{$t('upi-trans-id', 'UPI Transaction Id')}}</span>
                    <span class="type_t">925109698898</span>
                </div>

                <div class="flex flex-col">
                    <span class="upi_d">To: Shop</span>
                    <span class="type_t">9079313982@indus</span>
                </div>
                <div class="flex flex-col">
                    <span class="upi_d">From: Lotus ( IDFC Bank )</span>
                    <span class="type_t">Lotus18-1@okicici</span>
                </div>
                <div class="flex flex-col">
                    <span class="upi_d">Google transection ID</span>
                    <span class="type_t">CICAhuffk-ec</span>
                </div>
            </div>
        </div>

        <div class="notes_div">
            <span class="count">3</span>
            <div class="n_cont">
                <span class="heading">{{$t('upload-proof', 'Upload Proof')}}</span>
                <span class="c_text">{{$t('upload-trans-screenshot', 'Upload transaction Screenshot.')}}</span>
            </div>
        </div>
        <div class="notes_div">
            <span class="count">4</span>
            <div class="n_cont">
                <span class="heading">{{$t('submit', 'Submit')}}</span>
                <span class="c_text">{{$t('submit-form', 'Submit the form & Receive credits instantly.')}}</span>
            </div>
        </div>
    </div>
    <!---Terms & Conditions modal--->
    <div class="rules-modal-popup rules_m">
        <div class="modal fade" id="tc-modal-popup" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-0 p-0">
                        <button type="button" class="btn-cl" data-bs-dismiss="modal" aria-label="Close">
                            <img src="@/assets/images/close_m.svg" alt="m_close" />
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="flex flex-col gap-y-2" style="max-height: 450px; overflow-y: auto;">
                            <div class="text-base font-lato font-semibold text-text_Ternary">{{$t('terms-and-conditions', 'Terms and Conditions')}}:</div>
                            <div class="text-text_Ternary f_size">
                                <div>
                                    <h3>
                                        <span style="color: rgb(0, 168, 133);"><span style="font-size: 20px;">3% {{$t('real-cash-deposit', 'Real Cash on Every Deposit')}}</span> </span><br />
                                        {{$t('no-wagering-required', 'No Wagering required')}}
                                    </h3>
                                    <h3>
                                        Min deposit:&nbsp;300&nbsp;<br />
                                        Maximum Winning:5% of your deposit up to 5000
                                    </h3>
                                    <p>Conditions</p>
                                    <h3>
                                        Bonus amount: 5% of Deposit up to 5000 on every deposit<br />
                                        Min deposit: 300<br />
                                        Expiry: No Expiry
                                    </h3>
                                    <p>
                                        To get the bonus in the main wallet:&nbsp;<br />
                                        Make a Deposit and Get 3%&nbsp;Real cash&nbsp;immediately in your main wallet.
                                    </p>
                                    <p>Withdrawal will lead to the cancellation of free money and any active bonus from the wallet.</p>
                                    <p>General Terms</p>
                                    <ul>
                                        <li>
                                            <p>Once claimed, the free money bonus amount will be transferred to the customer's Main wallet immediately.</p>
                                        </li>
                                        <li>
                                            <p>The company has the right to amend the terms of the offer, cancel or renew the request, or refuse to allow participation at any time without prior notice.</p>
                                        </li>
                                        <li>
                                            <p>Players found to have multiple accounts to abuse the bonus system may have their bonuses and winnings voided.</p>
                                        </li>
                                    </ul>
                                    <p>
                                        By claiming the 3% deposit bonus up to 5000, you acknowledge that you have read, understood, and agreed to these terms and conditions. In case of any dispute, our decision will be final and
                                        binding.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!---the terms of payment and withdrawal policy modal--->
    <div class="rules-modal-popup rules_m">
        <div class="modal fade" id="wpolicy-modal-popup" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-0 p-0">
                        <button type="button" class="btn-cl" data-bs-dismiss="modal" aria-label="Close"><img src="@/assets/images/close_m.svg" alt="m_close" /></button>
                    </div>
                    <div class="modal-body p-2">
                        <div class="flex flex-col gap-y-2" style="max-height: 450px; overflow-y: auto;">
                            <div class="text-base font-lato font-semibold text-text_Ternary">Terms and Conditions:</div>
                            <div class="text-text_w_policy">
                                <p>
                                    Limits The maximum deposit limit on your account will vary depending on how long you have been a customer with us and whether you have successfully passed our security checks. Please contact the
                                    <span class="px-1 font-bold text-sm text-text_Primary">{{$siteSettings?.data?.social_link?.email}}</span>for further information
                                </p>
                                <p>
                                    Security Please note you may be asked to supply proof of identity and address before making a withdrawal from your account. Credit and Debit card payments undergo a 3D Secure process. To find out
                                    more, please click here.
                                </p>
                                <p>
                                    Withdrawals Withdrawals will be directed to the same source. If your query is not covered by the information contained here, please email
                                    <span class="px-1 font-bold text-sm text-text_Primary">{{$siteSettings?.data?.social_link?.email}}</span> where staff will be on hand to answer your query.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    name:'DepositTermsAndConditionModals',
}
</script>